import {RolePermission} from "@/models/Enums";

export default class InviteUserPostRequest {
    public organizationId: string | null= null;

    public contractId: string | null = null;

    public usersList: InvitedUser[] = [];

    public accessToAllConstructionSites: boolean = false;

    public companyMainUserRole: boolean = false;

    public rolePermission: RolePermission = RolePermission.None;

    public constructionSiteAccesses: IConstructionSiteAccess[] = [];
}

export const constructRolePermission = (companyMainUserRole: boolean,
    hasDirectRentAccess: boolean,
    hasPricesVisibleAccess: boolean): RolePermission => {
    if (companyMainUserRole) {
        return RolePermission.FullAccess;
    }

    let permission = RolePermission.CanSeeDetails;

    if (hasDirectRentAccess) {
        permission |= RolePermission.CanRentWithoutApproval;
    }

    if (hasPricesVisibleAccess) {
        permission |= RolePermission.CanSeePrices;
    }

    return permission;
}

export class InvitedUser {
    public firstName: string = "";

    public lastName: string = "";

    public telephone: string = "";

    public email: string = "";

    constructor(telephone: string, firstName: string = "", lastName: string = "", email: string = "") {
        this.telephone = telephone;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }
}

export interface IConstructionSiteAccess {
    access: boolean;
    directRentAccess: boolean;
    fullAccess: boolean;
    id: string;
    name: string;
    pricesVisible: boolean;
    isOpen: boolean;
    group?: string;
}